import React from 'react';
import { Typography } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { calculPrice } from './index';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Text } = Typography



export default (formPlugin, namespace) =>
{
    const POSITION_VERTICAL = [
        `Haut`,
        `Milieu`,
        `Bas`
    ]

    const POSITION_HORIZONTAL = [
        `Gauche`,
        `Centre`,
        `Droite`
    ]

    return {
        Renderer: (props) => {

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            const { data } = props

            let alignItems = "flex-end"
            let justifyContent = "flex-end"

            switch (data.vertical_position) {
                case POSITION_VERTICAL[0]:
                    alignItems = "flex-start"
                    break;
                case POSITION_VERTICAL[1]:
                    alignItems = "center"
                    break;
                case POSITION_VERTICAL[2]:
                    alignItems = "flex-end"
                    break;
            }

            switch (data.horizontal_position) {
                case POSITION_HORIZONTAL[0]:
                    justifyContent = "flex-start"
                    break;
                case POSITION_HORIZONTAL[1]:
                    justifyContent = "center"
                    break;
                case POSITION_HORIZONTAL[2]:
                    justifyContent = "flex-end"
                    break;
            }

            var style = { display: "flex", alignItems: alignItems, justifyContent: justifyContent }
            var textStyle = {}

            if (data.fontSize) {
                textStyle.fontSize = data.fontSize
            }

            const finalAmount = calculPrice(formPlugin.formValues, formPlugin.formData)
            const formatedAmount = formPlugin.currencyFormat(finalAmount / 100)
            const isAbo=formPlugin.formData?.paiementType==="MONTHLY"

            return (
                <div style={style}>
                    <Text style={textStyle}>
                        <Trans>{data.label || t`Total`} :</Trans> {finalAmount > 0 ? formatedAmount : 0} {isAbo && (<Trans>/ Mois</Trans>)}
                    </Text>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-product-total' + namespace,
        title: t`Total`,
        description: t`Élément de formulaire utilisable.`,
        icon: <DollarOutlined />,
        iconColor: "#8E44AD",
        version: 1,
        hideInMenu: formPlugin.formData.type !== "COMPLEX",
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    vertical_position: {
                        type: "string",
                        uniforms: {
                            showIf: () => false,
                            label: t`Positionnement Vertical`,
                            allowedValues: POSITION_VERTICAL,
                        }
                    },
                    horizontal_position: {
                        type: "string",
                        uniforms: {
                            label: t`Positionnement Horizontal`,
                            allowedValues: POSITION_HORIZONTAL,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Titre`,
                            placeholder: t`Total`,
                        }
                    },
                    fontSize: {
                        type: 'number',
                        uniforms: {
                            label: t`Taille de police`,
                            placeholder: t`pixel`,
                        }
                    },
                }
            },
        },
    }
}
